import { makeStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import GoogleMapsAutoComplete from "components/GoogleMapsAutoComplete";
import { isPast } from "date-fns";
import React from "react";
import { useSelector } from "react-redux";
import { CarouselView } from "v2/components/coursel";
import { Footer } from "v2/components/footer";
import { Header } from "v2/components/hearder";
import { calculeDistance, calculePrice, formatDate, formatTime } from "v2/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  center: {
    display: "flex",
    justifyContent: "center",
    "@media only screen and (max-width: 1280px)": {
      flexDirection: "column",
    },
  },
  item: {
    background: "rgba(196, 196, 196, 0.14)",
    padding: 20,
    margin: 20,
    width: "100%",
    borderRadius: 15,
    "@media only screen and (max-width: 1280px)": {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  itemcarousel: {
    padding: 0,
    margin: 20,
    width: "100%",
    marginTop: "auto",
    marginBottom: "auto",
    "@media only screen and (max-width: 1280px)": {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  title: {
    fontWeight: 700,
    paddingLeft: 16,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    border: "rgba(196, 196, 196, 0.14)",
  },
  field: {
    padding: 16,
    width: "100%",
    fontWeight: 600,
    fontSize: 16,
    height: 50,
    border: "rgba(196, 196, 196, 0.14)",
    background: "white",
    "&>*": {
      border: "rgba(196, 196, 196, 0.14)",
    },
    "&>.MuiInput-root": {
      fontWeight: 600,
      fontSize: 16,
    },
    "&&&>:before": {
      borderBottom: "none",
    },
    "&&>:after": {
      borderBottom: "none",
    },
  },
  divInput: {
    padding: 16,
    display: "flex",
    justifyContent: "space-between",
  },
  circleProgress: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    justifyItems: "center",
    marginLeft: "auto",
    marginRight: "auto",
  },
  colorPrimary: {
    backgroundColor: "#c4c4c4",
  },
  btn: {
    padding: 16,
    width: "100%",
    fontWeight: 700,
    fontSize: 14,
    border: "rgba(196, 196, 196, 0.14)",
    background: "#C4C4C4",
    cursor: "pointer",
  },
}));

const defaultForm = {
  destination: null,
  depart: null,
  jour: formatDate(),
  heure: formatTime(),
  voiture: null,
  totalCost: 0,
};

export default function Home(props) {
  const styles = useStyles();
  const cartypes = useSelector((state) => state.cartypes.cars);
  const [commandeForm, setCommandeForm] = React.useState(defaultForm);
  const [submited, setSubmeted] = React.useState(false);
  const onChangeHandler = (eventCahange) => {
    eventCahange.persist();
    setCommandeForm((prev) => ({
      ...prev,
      [eventCahange.target.name]: eventCahange.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    setSubmeted(true);
    e.preventDefault();
    e.persist();
    const distance = await calculeDistance(commandeForm.depart, commandeForm.destination);
    if (!distance) {
      return;
    }
    const totalCost = calculePrice(distance, commandeForm.voiture);
    setCommandeForm((prev) => ({
      ...prev,
      totalCost: totalCost.totalCost,
    }));

    setSubmeted(false);

    props.history.push({
      pathname: "/confirmation",
      state: {
        commandeInfo: JSON.stringify({
          ...commandeForm,
          totalCost: totalCost.totalCost,
          estimate: {
            totalCost: totalCost.totalCost,
            distance: distance.distance.value,
          },
        }),
      },
    });
  };

  React.useEffect(() => {
    if (cartypes !== null) {
      setCommandeForm((prev) => ({ ...prev, voiture: cartypes[0] }));
    }
  }, [cartypes]);

  const formIsNotOk = React.useMemo(() => Object.keys(commandeForm).find((key) => commandeForm[key] === null), [commandeForm]);
  const isValidDate = React.useMemo(() => isPast(commandeForm.jour), [commandeForm]);
  //TODO:: add some test for time and date
  return (
    <div className={styles.root}>
      <Header />
      <div className={styles.center}>
        <div className={styles.item}>
          <h5 className={styles.title}>Votre chauffeur privé, adapté à vos besoins. Réservation à faire 1h avant le départ.</h5>
          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.divInput}>
              <GoogleMapsAutoComplete
                placeholder="Votre adresse de départ"
                className={styles.field}
                onChange={(value) => {
                  setCommandeForm((prev) => ({ ...prev, depart: value }));
                }}
              />
            </div>
            <div className={styles.divInput}>
              <GoogleMapsAutoComplete
                placeholder="Votre adresse de destination"
                className={styles.field}
                onChange={(value) => {
                  setCommandeForm((prev) => ({ ...prev, destination: value }));
                }}
              />
            </div>
            <div
              style={{
                display: commandeForm.destination && commandeForm.depart ? "block" : "none",
              }}
            >
              <div className={styles.divInput}>
                <input
                  placeholder="Jour de départ"
                  className={styles.field}
                  type="date"
                  defaultValue={formatDate()}
                  value={commandeForm.jour}
                  name="jour"
                  onChange={onChangeHandler}
                />
                <input
                  style={{
                    marginLeft: 10,
                  }}
                  placeholder="Heure de départ"
                  className={styles.field}
                  type="time"
                  defaultValue={formatTime()}
                  value={commandeForm.heure}
                  name="heure"
                  onChange={onChangeHandler}
                />
              </div>
              <div className={styles.divInput}>
                <select
                  className={styles.field}
                  value={commandeForm.voiture?.id}
                  name="voiture"
                  onChange={(e) => {
                    setCommandeForm((prev) => ({
                      ...prev,
                      voiture: cartypes[e.target.value],
                    }));
                  }}
                >
                  {cartypes &&
                    Object.keys(cartypes).map((key) => {
                      let car = cartypes[key];
                      return (
                        <option value={key} key={key}>
                          {car.name}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>

            <div className={styles.divInput}>
              {submited ? (
                <div className={styles.circleProgress}>
                  <CircularProgress color="inherit" />
                </div>
              ) : (
                <button className={styles.btn} type="submit" disabled={formIsNotOk}>
                  Commander
                </button>
              )}
            </div>
          </form>
        </div>
        <div className={styles.itemcarousel}>
          <CarouselView />
        </div>
      </div>
      <Footer />
    </div>
  );
}
